import { createFileRoute } from "@tanstack/react-router"
import ProjectDataPage from "@/components/coreAnalytics/ProjectDataPage"

export const Route = createFileRoute("/core/analytics/project-data")({ component: ProjectDataPage })
